"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Carousel = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Carousel = require("./Carousel.styled");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var ArrowDownCircleIcon = function ArrowDownCircleIcon(props) {
  return _react.default.createElement("svg", props, _react.default.createElement("path", {
    d: "M18 19.734L16.266 21V7.5c0-.75-.516-1.266-1.266-1.266s-1.266.516-1.266 1.266V21L12 19.734c-.61-.375-1.36-.234-1.734.235-.375.61-.235 1.36.234 1.734l3 2.11c.375.234.984.515 1.5.515s.984-.14 1.5-.515l3-2.11c.516-.375.75-1.125.234-1.734-.468-.61-1.218-.61-1.734-.235z"
  }), _react.default.createElement("path", {
    d: "M15 0C6.75 0 0 6.75 0 15s6.75 15 15 15 15-6.75 15-15S23.25 0 15 0zm0 27.516C8.11 27.516 2.484 21.89 2.484 15S8.11 2.484 15 2.484 27.516 8.109 27.516 15c0 6.89-5.625 12.516-12.516 12.516z"
  }));
};

ArrowDownCircleIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  viewBox: "0 0 30 30"
};

var Carousel =
/*#__PURE__*/
function (_Component) {
  _inherits(Carousel, _Component);

  function Carousel(props) {
    var _this;

    _classCallCheck(this, Carousel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Carousel).call(this, props));

    _this.handleResize = function () {
      _this.setState({
        currentIndex: 1,
        moveBy: 0
      });
    };

    _this.getMoveBy = function (index) {
      return -index * 100 / _react.default.Children.count(_this.props.children);
    };

    _this.handleIndexChange = function (index) {
      var children = _this.props.children;

      if (index >= 0 && index < _react.default.Children.count(children)) {
        _this.setState({
          currentIndex: index,
          moveBy: _this.getMoveBy(index)
        });
      }
    };

    _this.handleHover = function (event, index) {
      event.preventDefault();

      _this.setState({
        currentIndex: index
      });
    };

    _this.renderIndicators = function () {
      var currentIndex = _this.state.currentIndex;
      var children = _this.props.children;
      return _react.default.Children.map(children, function (child, index) {
        return _react.default.createElement(_Carousel.StyledIndicator, {
          active: index === currentIndex,
          onClick: function onClick(event) {
            return _this.handleIndexChange(index);
          }
        });
      });
    };

    _this.state = {
      currentIndex: props.startIndex || 0,
      moveBy: props.startIndex && _this.getMoveBy(props.startIndex) || 0
    };
    return _this;
  }

  _createClass(Carousel, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = this.props.children;
      var _this$state = this.state,
          currentIndex = _this$state.currentIndex,
          moveBy = _this$state.moveBy;
      return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Carousel.StyledCarouselContainer, null, _react.default.createElement(_Carousel.StyledIcon, {
        previous: true,
        disabled: currentIndex === 0,
        width: "24px",
        height: "24px",
        onClick: function onClick() {
          return currentIndex > 0 && _this2.handleIndexChange(currentIndex - 1);
        }
      }, _react.default.createElement(ArrowDownCircleIcon, null)), _react.default.createElement(_Carousel.StyledContentContainer, null, _react.default.createElement(_Carousel.StyledCarousel, {
        childCount: _react.default.Children.count(children),
        moveBy: moveBy
      }, _react.default.Children.map(children, function (child, index) {
        return _react.default.cloneElement(child, {
          currentChild: currentIndex + 1,
          onMouseOver: function onMouseOver(event) {
            return window.innerWidth >= 1024 && _this2.handleHover(event, index) || event.preventDefault();
          }
        });
      }))), _react.default.createElement(_Carousel.StyledIcon, {
        disabled: currentIndex === _react.default.Children.count(children) - 1,
        width: "24px",
        height: "24px",
        onClick: function onClick() {
          return currentIndex < _react.default.Children.count(children) - 1 && _this2.handleIndexChange(currentIndex + 1);
        }
      }, _react.default.createElement(ArrowDownCircleIcon, null))), _react.default.createElement(_Carousel.StyledIndicatorsContainer, null, this.renderIndicators()));
    }
  }]);

  return Carousel;
}(_react.Component);
/**
 * Definition of default values for component props
 */


exports.Carousel = Carousel;
Carousel.defaultProps = {
  children: undefined,
  startIndex: 1
};
Carousel.propTypes = {
  /** Content to be rendered in the Carousel */
  children: _propTypes.default.node,

  /** Which image to display first on mobile when Carousel is rendered
   *  0 based index
   */
  startIndex: _propTypes.default.number
};